import { NgModule } from '@angular/core';
import { AgGridClientPaginationDirective } from '@iris/common/modules/grid/ag-grid/extensions/client-pagination/client-pagination.directive';

@NgModule({
  declarations: [
    AgGridClientPaginationDirective,
  ],
  exports: [
    AgGridClientPaginationDirective,
  ],
})
export class AgGridClientPaginationModule {
}
